import {Injectable} from '@angular/core';
import {ApiService} from '../../api/api.service';
import {Observable} from 'rxjs';
import {CreateRoleDto} from "../../../../pages/management/authorization-management/dtos/role/create-role.dto";
import {IRole, IRoleAssign} from "../../../../pages/management/authorization-management/models/roles.interface";
import {IPagination} from "../../api/interface/pagination.interface";

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  constructor(private readonly apiService: ApiService) {
  }

  getFilter(event: any, filter: any): Observable<IPagination> {
    return this.apiService.getFilter<IPagination>(`role/role-filter-list`, {event: event, filter: filter})
  }

  getList() {
    return this.apiService.get<any>('role')
  }

  getById(roleId: string | number) {
    return this.apiService.get<any>(`role/${roleId}`)
  }

  create(role: CreateRoleDto): Observable<IRole> {
    return this.apiService.post<IRole>('role/create', role)
  }

  update(role: IRole): Observable<IRole> {
    return this.apiService.patch<IRole>(`role/update`, role);
  }

  delete(roleId: string,): Observable<IRole> {
    return this.apiService.delete<IRole>(`role/delete/${roleId}`);
  }

  assignUser(assignData: any[]) {
    return this.apiService.post<any>('role/add-user', assignData)
  }

  unassignUser(assignData: any[]) {
    return this.apiService.post<any>('role/remove-users', assignData)
  }

  assignAuthorityGroup(assignData: IRoleAssign[]) {
    return this.apiService.post<any>('role/add-authority-group', assignData)
  }

  unassignAuthorityGroup(assignData: IRoleAssign[]) {
    return this.apiService.post<any>('role/remove-authority-groups', assignData)
  }
}


